import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SoftwarePackageConfig } from 'src/app/models/software-package-config';
import { apiConstants } from 'src/app/shared/constants/endpoints';
import { HttpService } from 'src/app/shared/services/http/http.service';
import { map } from 'rxjs/operators'
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class TwinService {
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };
  constructor(private http: HttpService) { }

  public cancelPackageConfiguration(container: string, config: SoftwarePackageConfig): Observable<any> {
    const user = localStorage.getItem('userName');
    const url = `${apiConstants.cancelSoftwarePackage}/${container}?user=${user}`;
    return this.http.post(url, config).pipe(map(r => r as Observable<any>));
  }

  public getFilteredTwins(hubFilter: string, sqlFilter: string, isCalledFrom: string): Observable<any> {
    let url: string;
    url =  isCalledFrom == "Device Search" ? `${apiConstants.getDeviceTwinByFilterDeviceSearch}?` : `${apiConstants.getDeviceTwinByFilter}?`;
    if (hubFilter) {
      url = `${url}&hubFilter=${encodeURIComponent(hubFilter)}`;
    }
    if (sqlFilter) {
      url = `${url}&sqlFilter=${encodeURIComponent(sqlFilter)}`;
    }
    if (isCalledFrom) {
      url = `${url}&isCalledFrom=${isCalledFrom}`;
    }
    return this.http.post(url, this.httpOptions);
  }

  public addPackageConfiguration(container: string, config: SoftwarePackageConfig): Observable<any> {
    const user = localStorage.getItem('userName');
    const url = `${apiConstants.getSoftwareDeploymentStatus}/${apiConstants.softwarePackageConfig}/${container}?user=${user}`;
    return this.http.post(url, config).pipe(map(r => r as Observable<any>));
  }
}
